import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ManageTerminologyStateClass } from './interfaces/manageTerminologyStateClass';
const initialState: ManageTerminologyStateClass = {
    isLoading: false,
    status: 'idle',
    manageTerminologyList: [],
    selectedRecord: {},
    isReload: false
}
interface IThunkApi {
    state: {
        manageTerminology: ManageTerminologyStateClass;
    },
}
export const getManageTerminologyAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'manageTerminology/ManageTerminology',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ManageTerminology', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const UpdateManageTerminologiesAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'manageTerminology/UpdateManageTerminologies',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/ManageTerminology/UpdateManageTerminologies', 'PUT', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )



export const manageTerminologySlice = createSlice({
    name: 'manageTerminology',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        checkedState: (state, action) => {
            const currentindex = action.payload;
            const newArray = [...state.manageTerminologyList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.manageTerminologyList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = action.payload;
            const newArray = [...state.manageTerminologyList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.manageTerminologyList = newArray;
        },
        setValuesmanageTerminologyList: (state, action) => {
            const { Index, value, FieldName } = action.payload;
            const newArray = [...state.manageTerminologyList];
            if (FieldName === 'TerminologyName') {
                newArray[Index] = { ...newArray[Index], TerminologyName: value };
            }
            if (FieldName === 'UserDefinedName') {
                newArray[Index] = { ...newArray[Index], UserDefinedName: value };
            }
            state.manageTerminologyList = newArray;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getManageTerminologyAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getManageTerminologyAsync.fulfilled, (state, { payload }) => {

                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    state.manageTerminologyList = [];
                } else {
                    state.manageTerminologyList = payload.Data;
                    state.manageTerminologyList.map((item: any) => {
                        if (item.AccountTerminologyId > 0) {
                            item.isSelected = 1
                        } else {
                            item.isSelected = 0
                        }

                    });
                }
                state.isReload = false;
                state.selectedRecord = {};
                state.isLoading = false;

            })
            .addCase(getManageTerminologyAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })


            .addCase(UpdateManageTerminologiesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(UpdateManageTerminologiesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;

            })
            .addCase(UpdateManageTerminologiesAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })

    }
})
export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, setValuesmanageTerminologyList } = manageTerminologySlice.actions
export const manageTerminologyStateClass = (state: RootState) => state.manageTerminology
export default manageTerminologySlice.reducer